import { ImageFieldImage, RichTextField } from '@prismicio/client';
import PageHeroRedesign from '@/components/redesign/PageHeroRedesign';

/**
 * Full-bleed blog-post hero. Not a Prismic slice — driven by the `blog` document
 * fields (`image` + `card_title`). Delegates the layout/visuals to the shared
 * `PageHeroRedesign` component (kept in sync with the `HeroVelxEngine` redesign
 * variant) with `applyBottomGradient` on so the brand-green fade shows behind
 * the title.
 */

interface BlogHeroProps {
  image: ImageFieldImage;
  title: RichTextField;
  /** Small uppercase label above the title. Defaults to "BLOG" (per design). */
  kicker?: string;
  imageLayout?: 'cover' | 'fill';
}

export function BlogHero({
  image,
  title,
  kicker = 'BLOG',
  imageLayout = 'cover',
}: BlogHeroProps) {
  return (
    <PageHeroRedesign
      eyebrow={kicker}
      title={title}
      backgroundImage={image}
      applyBottomGradient
      imageLayout={imageLayout}
    />
  );
}
